"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var buttonCell = function buttonCell(theme) {
  return /*#__PURE__*/(0, _react.css)("width:100%;text-align:left;color:", theme.color.monochrome.black, ";font-weight:", theme.fontWeight.medium, ";cursor:pointer;text-decoration:none;display:block;&:hover{color:", theme.color.primary.brand, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:buttonCell;"));
};

var styles = {
  buttonCell: buttonCell
};
exports.styles = styles;
//# sourceMappingURL=CellWithButton.styles.js.map